import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MuiTypography from "@material-ui/core/Typography";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      boxShadow: "none",
      borderBottom: `1px solid ${theme.palette.divider}`,
      "&:before": {
        display: "none",
      },
    },
    question: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    answer: {
      color: theme.palette.text.secondary,
    },
  });

export interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

function FAQAccordion(props: FAQAccordionProps & WithStyles<typeof styles>) {
  const { items, classes } = props;

  return (
    <div>
      {items.map((item, index) => (
        <Accordion key={index} className={classes.root}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`faq-content-${index}`}
            id={`faq-header-${index}`}
          >
            <MuiTypography variant="body1" className={classes.question}>
              {item.question}
            </MuiTypography>
          </AccordionSummary>
          <AccordionDetails>
            <MuiTypography variant="body1" className={classes.answer}>
              {item.answer}
            </MuiTypography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}

export default withStyles(styles)(FAQAccordion);
